import request from '../_helpers/request';

export const SourcingService = {
    GetBuyerRequestMatchingByCompidAsync
};

//根据公司id 获取 该公司想配备的采购需求
function GetBuyerRequestMatchingByCompidAsync(query) {
    return request({
      url: 'Sourcing/GetBuyerRequestMatchingByCompidAsync',
      method: 'get',
      params: query
    })
}

  
// export function addNotice(data) {
//     return request({
//       url: '/system/notice',
//       method: 'post',
//       data: data
//     })
// }